export const DEFAULT_CELL_WIDTH = 120;

export const CELL_WIDTHS = {
    "no": 80,
    "section": 150,
    "severity": 120,
    "description": 200,
    "location": 200,
    "current_value": 200,
    "expected_value": 200,
    "impact": 300,
    "action_required": 400,
    "team": 100,
    "entity_name": 200,

}

export const VIEW_OPTION_IDS = {
  EXCEPTION: "exception",
  ALL: "all",
}

export const VIEW_OPTIONS =[{
  text: "Exception only view",
  id: VIEW_OPTION_IDS.EXCEPTION
}, {
  text: "View all checks",
  id: VIEW_OPTION_IDS.ALL
}]

export const EXCEPTION_STATUSES = [
  "important",
  "fyi"
]

export const SEVERITY_ICONS = {
  "important": "⚠️",
  "fyi": "ℹ️",
  "no_issue": "✅",
}
